/* tslint:disable */
/* eslint-disable */
/**
 * Shared Service API
 * Shared Service API documentation.
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * The next step for the user
 * @export
 * @enum {string}
 */
export const UserNextStepEnum = {
    Login: 'login',
    Signup: 'signup',
    ChoosePassword: 'choose-password',
    ChoosePasswordCognito: 'choose-password-cognito',
    StaffFederatedSignin: 'staff-federated-signin',
};
